import { Button, type ButtonProps } from "@shared/components/ui/button"
import { cn } from "@shared/lib/utils"
import type { TableAction } from "@shared/types/data-table"

interface HoverActionsProps<T> {
  actions: TableAction<T>[]
  item: T
  className?: string
}

export function HoverActions<T>({ actions, item, className }: HoverActionsProps<T>) {
  if (!actions.length) return null

  return (
    <div className={cn(
      "flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200",
      className
    )}>
      {actions.map((action, index) =>
        action.renderAction ? (
          <div key={action.key || index} onClick={(e) => e.stopPropagation()}>
            {action.renderAction(item)}
          </div>
        ) : (
          <Button
            key={action.key || index}
            variant={(action.variant || "ghost") as ButtonProps["variant"]}
            size="sm"
            className="h-7 w-7 p-0 hover:bg-accent"
            onClick={(e) => {
              e.stopPropagation()
              action.onClick(item)
            }}
            disabled={action.disabled?.(item)}
            title={action.label}
          >
            {action.icon}
          </Button>
        )
      )}
    </div>
  )
}